import { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, TextField } from '@mui/material';

import calculateEnabledStatus from '../utils/calculateEnabledStatus';

QuestionnaireTextField.propTypes = {
  element: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func,
  values: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
};

function QuestionnaireTextField(props) {
  const { element, setFieldValue, values, readOnly } = props;

  const [notDisabled, setNotDisabled] = useState(true);

  const currentValue = useMemo(() => values[element.linkId] || '', [element.linkId, values]);

  useEffect(() => {
    if (element.enableBehavior) {
      const enableStatus = calculateEnabledStatus(element.enableBehavior, element.enableWhen, values);
      setNotDisabled(enableStatus !== undefined && enableStatus);
    }
  }, [element.enableBehavior, element.enableWhen, values]);

  const handleChange = useCallback((e) => {
    setFieldValue(element.linkId, e.target.value);
  }, [setFieldValue, element.linkId]);

  const renderInputProps = useCallback((element, readOnly) => {
    const inputProps = {};

    if (element?.extension) {
      const endAdornmentProps = element.extension.find(el =>
        el.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-unit"
      )?.valueCoding?.code;

      if (endAdornmentProps) {
        inputProps.endAdornment = <InputAdornment position="end">{endAdornmentProps}</InputAdornment>;
      }
    }

    if (readOnly) {
      inputProps.readOnly = true;
    }

    return inputProps;
  }, []);


  return (
    <TextField
      fullWidth
      disabled={!notDisabled}
      label={element.required ? `${element.text}*` : element.text}
      value={currentValue}
      onChange={handleChange}
      type={element.type === 'integer' || element.type === 'decimal' ? 'number' : 'text'}
      InputProps={renderInputProps(element, readOnly) || {}}
      variant={readOnly ? "standard" : "outlined"}
    />
  );
}

export default QuestionnaireTextField;
